module.exports = __webpack_public_path__ + "img/device_cb01.8d9dfcf5.png";